import { render, staticRenderFns } from "./RolePermissionNew.vue?vue&type=template&id=1e5e750a"
import script from "./RolePermissionNew.vue?vue&type=script&lang=js"
export * from "./RolePermissionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports